import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { pushRoute } from '../../utilities/helpers';

import { FETCH_CLIENT, FETCH_CLIENT_ERROR, SET_CLIENT } from '../constants';

const client = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_CLIENT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/client?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
            if(response.response.accountType === "collects") {
                pushRoute('/audience-builder-select-type');
            } else {
                pushRoute('/');
            }
          return {
            type: SET_CLIENT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_CLIENT_ERROR,
            error,
          })
        )
      )
    )
  );

export default client;
